import { trainingServe, deleteServe } from "@/utils/request";

const postAsset = (data, method = "post") => {
	return trainingServe({
		url: "/repository/asset-management/",
		method,
		data,
	});
};
const getAsset = (data) => {
	return trainingServe({
		url: "/repository/asset/",
		method: "post",
		data,
	});
};
const deleteFile = (data) => {
	return deleteServe({
		url: data,
		method: "delete",
		data,
	});
};

const cloneAsset = (data) => {
	return trainingServe({
		url: "/repository/clone-assest/",
		method: "post",
		data,
	});
};
const getTags = (data) => {
	return trainingServe({
		url: "/repository/asset-tags/",
		method: "post",
		data,
	});
};

export { postAsset, getAsset, deleteFile, cloneAsset, getTags };
